const track = (args) => {
  if (window.teads_e && window.teads_e.push) {
    window.teads_e.push(args);
  }
};

export default {
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_file_Conversion() {
    track({
      conversionType: 'PaidTransfer',
    });
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_plus_send_file_Conversion() {
    track({
      conversionType: 'PaidTransfer',
    });
  },
};
